var map = {
	"./Black_Account_Icons-01.png": 677,
	"./Black_Account_Icons-02.png": 678,
	"./Black_Account_Icons-03.png": 679,
	"./Black_Account_Icons-04.png": 680,
	"./Black_Account_Icons-05.png": 681,
	"./Black_Account_Icons-06.png": 682,
	"./Black_Account_Icons-07.png": 683,
	"./Black_Account_Icons-08.png": 684,
	"./Black_Account_Icons-09.png": 685,
	"./Black_Account_Icons-10.png": 686,
	"./Black_Account_Icons-11.png": 687,
	"./Black_Account_Icons-12.png": 688,
	"./Black_Account_Icons-13.png": 689,
	"./Black_Account_Icons-14.png": 690,
	"./FilePresentOutlined.svg": 691,
	"./accuracyAccountsDemo_downloadMT4.jpg": 692,
	"./accuracyAccountsReal_downloadMT4.jpg": 693,
	"./alert@2x.svg": 694,
	"./apple-brands.svg": 695,
	"./arrow_up_from_box.svg": 696,
	"./bankWire.svg": 697,
	"./bdswissDemo_downloadMT4.png": 698,
	"./bdswissGlobalDemo_downloadMT4.png": 699,
	"./bdswissGlobalReal02_downloadMT4.png": 700,
	"./bdswissGlobalReal03_downloadMT4.png": 701,
	"./bdswissGlobalReal04_downloadMT4.png": 702,
	"./bdswissGlobalReal05_downloadMT4.png": 703,
	"./bdswissGlobalReal_downloadMT4.png": 704,
	"./bdswissGlobalReal_downloadMT5.png": 705,
	"./bdswissReal02_downloadMT4.png": 706,
	"./bdswissReal03_downloadMT4.png": 707,
	"./bdswissReal04_downloadMT4.png": 708,
	"./bdswissReal05_downloadMT4.png": 709,
	"./bdswissReal_downloadMT4.png": 710,
	"./bdswissReal_downloadMT5.png": 711,
	"./bdswissSCDemo_downloadMT4.png": 712,
	"./bdswissSCReal01_downloadMT4.png": 713,
	"./bdswissSCReal02_downloadMT4.png": 714,
	"./bdswissSCReal03_downloadMT4.png": 715,
	"./bdswissSCReal04_downloadMT4.png": 716,
	"./bdswissSCReal05_downloadMT4.png": 717,
	"./bdswiss_grey.png": 718,
	"./bdswiss_white.png": 719,
	"./bg-image-affiliate.png": 720,
	"./bitwallet-bdSwiss-dark.svg": 721,
	"./bitwallet-bdSwiss-light.svg": 722,
	"./bitwallet-swissMarkets-dark.svg": 723,
	"./bitwallet-swissMarkets-light.svg": 724,
	"./card.svg": 725,
	"./check_circle.png": 726,
	"./chf.png": 727,
	"./competitions.png": 728,
	"./complimentary@2x.svg": 729,
	"./control-radio-off.png": 730,
	"./control-radio-on.png": 731,
	"./crypto.svg": 732,
	"./cvv.svg": 733,
	"./deposit-card.svg": 734,
	"./diners.png": 735,
	"./dkk.png": 736,
	"./document-upload-failure-dark.png": 737,
	"./document-upload-failure-light.png": 738,
	"./document-upload-success-black.png": 739,
	"./document-upload-success-dark.png": 740,
	"./document-upload-success-light.png": 741,
	"./documents-empty-dark.png": 742,
	"./documents-empty-light.png": 743,
	"./downloadPdf-light.png": 744,
	"./downloadPdf.png": 745,
	"./dpWorldTourChampionship-dark.svg": 746,
	"./dpWorldTourChampionship-light.svg": 747,
	"./eWallet.svg": 748,
	"./eur.png": 749,
	"./exp-date.svg": 750,
	"./fees@2x.svg": 751,
	"./filterIcon.png": 752,
	"./gbp.png": 753,
	"./icon-add-account.svg": 448,
	"./icon-appstore@2x.png": 754,
	"./icon-arrow-right-dark.png": 755,
	"./icon-arrow-right-light.png": 756,
	"./icon-bank-wire.svg": 757,
	"./icon-checkbox.svg": 758,
	"./icon-close-dark.svg": 759,
	"./icon-close-light.svg": 760,
	"./icon-close.png": 761,
	"./icon-contact-callback@2x.png": 762,
	"./icon-contact-callback@2x.svg": 763,
	"./icon-contact-chat@2x.png": 449,
	"./icon-contact-chat@2x.svg": 450,
	"./icon-contact-email@2x.png": 764,
	"./icon-contact-email@2x.svg": 765,
	"./icon-contact-faqs@2x.png": 766,
	"./icon-contact-faqs@2x.svg": 767,
	"./icon-contact-oneOnOneSession@2x.png": 768,
	"./icon-contact-telegram@2x.png": 769,
	"./icon-contact-whatsapp@2x.png": 770,
	"./icon-crypto.svg": 771,
	"./icon-document.svg": 772,
	"./icon-facebook@2x.png": 773,
	"./icon-google-play@2x.png": 774,
	"./icon-notification.svg": 775,
	"./icon-profile-big.svg": 776,
	"./icon-profile.svg": 777,
	"./icon-spoa.svg": 778,
	"./icon-swapFree.svg": 779,
	"./icon-telegram@2x.png": 780,
	"./icon-twitter@2x.png": 781,
	"./icon_accounts_dashboard.svg": 782,
	"./icon_logout_dashboard.svg": 783,
	"./icon_notification_dashboard.svg": 784,
	"./icon_profilesettings_dashboard.svg": 785,
	"./icon_support_dashboard.svg": 786,
	"./icon_transaction_dashboard.svg": 787,
	"./jcb.png": 788,
	"./knet-logo.png": 451,
	"./languages.png": 789,
	"./limit-failure-dark.png": 790,
	"./limit-failure-light.png": 791,
	"./logo-accuracy.png": 792,
	"./logo-bdstrading-white.svg": 793,
	"./logo-bdstrading.svg": 794,
	"./logo-bdswiss-white.svg": 795,
	"./logo-bdswiss.png": 796,
	"./logo-bdswiss.svg": 797,
	"./logo-equityflow-black.png": 798,
	"./logo-equityflow-white.png": 799,
	"./logo-facebook.png": 800,
	"./logo-google.png": 801,
	"./logo-google.svg": 802,
	"./logo-lydian-black.png": 803,
	"./logo-lydian-black.svg": 804,
	"./logo-lydian-white.svg": 805,
	"./logo-regalx-white.png": 806,
	"./logo-regalx.png": 807,
	"./logo-skyground-black.svg": 808,
	"./logo-skyground-white.svg": 809,
	"./logo-swissmarkets-white.svg": 810,
	"./logo-swissmarkets.png": 811,
	"./logo-swissmarkets.svg": 812,
	"./logo-tauromarkets-black.png": 813,
	"./logo-tauromarkets-white.png": 814,
	"./logo-tauromarkets-white2.png": 815,
	"./logo-tauromarkets-white2.svg": 816,
	"./logo-valutamarkets.png": 817,
	"./maestro.png": 818,
	"./mastercard.png": 819,
	"./mastercard_logo_icon.svg": 820,
	"./mercedesCup-dark.svg": 821,
	"./mercedesCup-light.svg": 822,
	"./nationalIdBR.png": 823,
	"./nationalIdES.jpg": 824,
	"./nationalIdIT.jpg": 825,
	"./nationalIdZA.png": 826,
	"./no-trades-dark.png": 827,
	"./no-trades-light.png": 828,
	"./no-trading-signals-dark.png": 829,
	"./nok.png": 830,
	"./notifications-empty-dark.png": 831,
	"./notifications-empty-light.png": 832,
	"./onlineBanking.svg": 833,
	"./onlineDeposit.svg": 834,
	"./page-not-found-dark.svg": 452,
	"./page-not-found-light.svg": 453,
	"./payment-failure-dark.png": 835,
	"./payment-failure-light.png": 836,
	"./payment-pending-dark.png": 837,
	"./payment-pending-light.png": 838,
	"./payment-success-dark.png": 839,
	"./payment-success-light.png": 840,
	"./payments-history-empty-dark.png": 841,
	"./payments-history-empty-light.png": 842,
	"./phone_verification.png": 843,
	"./place1-leadership.png": 844,
	"./place2-leadership.png": 845,
	"./place3-leadership.png": 846,
	"./pln.png": 847,
	"./pof-bankStatement.png": 848,
	"./pof-bankStatementPOF.png": 849,
	"./pof-card-back.png": 850,
	"./pof-card.png": 851,
	"./pof-cardStatement.png": 852,
	"./pof-other.png": 853,
	"./pof-proofOfResidence.png": 854,
	"./pof-swiftCopyPaymentAdvice.png": 855,
	"./pof-virtualCard.png": 856,
	"./poi-document.png": 857,
	"./poi-drivingLicense-back.png": 858,
	"./poi-drivingLicense.png": 859,
	"./poi-id-back.png": 860,
	"./poi-id.png": 861,
	"./poi-passport.png": 862,
	"./por-bankStatementPOR.png": 863,
	"./por-document.png": 864,
	"./por-proofOfResidence.png": 865,
	"./por-utilityBill.png": 866,
	"./priority@2x.svg": 867,
	"./referAndEarn.png": 868,
	"./regalxDemo_downloadMT4.png": 869,
	"./regalxReal01_downloadMT4.png": 870,
	"./regalxReal02_downloadMT4.png": 871,
	"./regalxReal03_downloadMT4.png": 872,
	"./regalxReal04_downloadMT4.png": 873,
	"./regalxReal05_downloadMT4.png": 874,
	"./register-referral-light.png": 875,
	"./sek.png": 876,
	"./sign-up.png": 877,
	"./spaceship.png": 878,
	"./spreads@2x.svg": 879,
	"./support@2x.svg": 880,
	"./swissmarketsDemo_downloadMT4.png": 881,
	"./swissmarketsReal02_downloadMT4.png": 882,
	"./swissmarketsReal_downloadMT4.png": 883,
	"./tauroDemo01DownloadMT4.jpg": 884,
	"./tauroReal01DownloadMT4.jpg": 885,
	"./technicalIndicator-ebook.png": 886,
	"./technicalIndicatorItem.svg": 887,
	"./telegram-dark.png": 888,
	"./telegram.png": 889,
	"./trading-alerts-tradingAlerts-dark.png": 890,
	"./trading-alerts-tradingAlerts-light.png": 891,
	"./tradingPsychology-ebook.png": 892,
	"./tradingPsychologyItem.svg": 893,
	"./transfer-external.svg": 894,
	"./transfer-internal.svg": 895,
	"./transfer-spoa.svg": 896,
	"./upload-bankStatement-error.png": 897,
	"./upload-bankStatement-success.png": 898,
	"./upload-bankStatement.png": 899,
	"./upload-document-dark.png": 900,
	"./upload-document-light.png": 901,
	"./upload-generic-error.png": 902,
	"./upload-generic-success.png": 903,
	"./upload-generic.png": 904,
	"./upload-pof-back-card-error.png": 905,
	"./upload-pof-back-card-success.png": 906,
	"./upload-pof-back-card.png": 907,
	"./upload-pof-front-card-error.png": 908,
	"./upload-pof-front-card-success.png": 909,
	"./upload-pof-front-card.png": 910,
	"./upload-poi-back-drivingLicense-error.png": 911,
	"./upload-poi-back-drivingLicense-success.png": 912,
	"./upload-poi-back-drivingLicense.png": 913,
	"./upload-poi-back-error.png": 914,
	"./upload-poi-back-success.png": 915,
	"./upload-poi-back.png": 916,
	"./upload-poi-front-drivingLicense-error.png": 917,
	"./upload-poi-front-drivingLicense-success.png": 918,
	"./upload-poi-front-drivingLicense.png": 919,
	"./upload-poi-front-error.png": 920,
	"./upload-poi-front-success.png": 921,
	"./upload-poi-front.png": 922,
	"./upload-por-front-error.png": 923,
	"./upload-por-front-proofOfResidence-error.png": 924,
	"./upload-por-front-proofOfResidence-success.png": 925,
	"./upload-por-front-proofOfResidence.png": 926,
	"./upload-por-front-success.png": 927,
	"./upload-por-front-utilityBill-error.png": 928,
	"./upload-por-front-utilityBill-success.png": 929,
	"./upload-por-front-utilityBill.png": 930,
	"./upload-por-front.png": 931,
	"./usd.png": 932,
	"./visa.png": 933,
	"./visa_logo_icon.svg": 934,
	"./vps-enter-credentials.png": 935,
	"./vps-remote-desktop-windows.png": 936,
	"./vps-remote-desktop.png": 937,
	"./waiting-list-skip-dark.png": 938,
	"./waiting-list-skip.png": 939,
	"./windows-brands.svg": 940
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1349;